import { render, staticRenderFns } from "./camera-screenshot.vue?vue&type=template&id=2a56f0f9&"
import script from "./camera-screenshot.vue?vue&type=script&lang=js&"
export * from "./camera-screenshot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports